module.exports = __webpack_public_path__ + "img/kuaixun.d61226b4.png";